export const USER_LISTINGS_TAG = 'user-listings';
export const RECENT_SEARCH_TAG = 'recent-search';
